@if (isLoading) {
    <div class="loading">
        <div class="spinner-wrapper">
            <mat-spinner [diameter]="50" />
        </div>
    </div>
}
<div [hidden]="isLoading">
    <mat-dialog-content>
        <mat-stepper [linear]="true" #stepper>
            <mat-step [completed]="allVotesSelected">
                <ng-template matStepLabel>{{ 'AgendaItems.Instructions' | translate }}</ng-template>
                <div class="row mb-3">
                    @if (hasPresetInstructions) {
                        <div class="col-12 col-md-6">
                            <h2>
                                {{ 'AgendaItems.VotingInstructionsProxy' | translate }}
                            </h2>
                        </div>
                    }
                    <!--
                    ################################################################################################
                    TODO: ng-container TEMPORARY HACK - WILL BE REMOVED IN 4 WEEKS
                    OBS: If it's pass May, 1st 2026 and this is still here, just remember, we meant well
                    ################################################################################################
                    -->
                    @if (!isMS) {
                        <div class="col-12 col-md-6 text-center" [ngClass]="{ 'offset-md-6': !hasPresetInstructions === true }">
                            <button mat-flat-button (click)="acceptMotionBoD()" color="primary" class="w-100">
                                <mat-icon>check</mat-icon>
                                {{ 'AgendaItems.AcceptMotionBoardDirectors' | translate }}
                            </button>
                        </div>
                    }
                </div>
                <div>
                    @for (data of items; track data.gmAgendaItemNumber; let i = $index) {
                        <div
                            class="row small-gutters-mobile instructions"
                            [class.child]="data.parentGmAgendaItemNumber > 0"
                            [class.-first-child]="
                                data.parentGmAgendaItemNumber > 0 && data.parentGmAgendaItemNumber !== items[i - 1].parentGmAgendaItemNumber
                            "
                            [class.hasError]="data.hasError"
                            #agendaItemRow>
                            <div class="col-12 col-lg-6">
                                <span class="number">{{ data.number }}</span>
                                <span class="description">{{ data.description }}</span>
                            </div>
                            <div class="col-4 col-lg-2 mt-1 mt-lg-0 radio-button-cell yes-cell">
                                @if (!hasChildren(data)) {
                                    <button
                                        mat-flat-button
                                        (click)="changeVote(data.gmAgendaItemNumber, VoteOptionEnum.Yes)"
                                        class="positive w-100"
                                        [class.selected]="isChecked(data.gmAgendaItemNumber.toString(), VoteOptionEnum.Yes)">
                                        {{ 'Voting.Yes' | translate }}
                                    </button>
                                }
                            </div>
                            <div class="col-4 col-lg-2 mt-1 mt-lg-0 no-cell">
                                @if (!hasChildren(data)) {
                                    <button
                                        mat-flat-button
                                        (click)="changeVote(data.gmAgendaItemNumber, VoteOptionEnum.No)"
                                        class="negative w-100"
                                        [class.selected]="isChecked(data.gmAgendaItemNumber.toString(), VoteOptionEnum.No)">
                                        {{ 'Voting.No' | translate }}
                                    </button>
                                }
                            </div>
                            <div class="col-4 col-lg-2 mt-1 mt-lg-0 abstention-cell">
                                @if (!hasChildren(data)) {
                                    <button
                                        mat-flat-button
                                        (click)="changeVote(data.gmAgendaItemNumber, VoteOptionEnum.Abstention)"
                                        class="neutral w-100"
                                        [class.selected]="isChecked(data.gmAgendaItemNumber.toString(), VoteOptionEnum.Abstention)">
                                        {{ 'Voting.Abstain' | translate }}
                                    </button>
                                }
                            </div>
                        </div>
                    }
                </div>
            </mat-step>
            @if (showAdditionalProposalsStep) {
                <mat-step
                    [completed]="
                        selectedAdditionalProposals.length > 0 && (currentGM.splitInstructions ? selectedNewItems.length > 0 : true)
                    ">
                    <div class="additional-proposals">
                        <ng-template matStepLabel>{{ 'AgendaItems.AdditionalProposalsAmendments' | translate }}</ng-template>
                        <h4 class="mat-h4">{{ instructionsText }}</h4>
                        @if (!isLoading) {
                            <form [formGroup]="formGroup">
                                <div class="row">
                                    <div class="col-12 col-md-8">
                                        <mat-form-field class="w-100">
                                            <mat-label>
                                                {{ 'AgendaItems.AdditionalProposalsAmendmentsField' | translate }}
                                            </mat-label>
                                            <mat-select [formControl]="formGroup.controls['additionalProposals'] | formControl">
                                                @for (item of votingInstructions; track item.id) {
                                                    <mat-option [value]="item.id">
                                                        {{ item.label }}
                                                    </mat-option>
                                                }
                                            </mat-select>
                                            <mat-error>
                                                <sl-form-field-error-control [control]="formGroup.controls['additionalProposals']" />
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                                @if (currentGM?.splitInstructions) {
                                    <div class="row">
                                        <div class="col-12 col-md-8">
                                            <mat-form-field class="w-100">
                                                <mat-label>
                                                    {{ 'AgendaItems.NewItems' | translate }}
                                                </mat-label>
                                                <mat-select [formControl]="formGroup.controls['newItems'] | formControl">
                                                    @for (item of votingInstructions; track item.id) {
                                                        <mat-option [value]="+item.id">
                                                            {{ item.label }}
                                                        </mat-option>
                                                    }
                                                </mat-select>
                                                <mat-error>
                                                    <sl-form-field-error-control [control]="formGroup.controls['newItems']" />
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                }
                            </form>
                        }
                    </div>
                </mat-step>
            }
            <mat-step>
                <div class="review-accept-terms">
                    <ng-template matStepLabel>{{ 'AgendaItems.ReviewAcceptTerms' | translate }}</ng-template>
                    <h2 class="mat-h2">{{ 'AgendaItems.Instructions' | translate }}</h2>
                    <table mat-table [dataSource]="items">
                        <ng-container matColumnDef="number">
                            <td mat-cell *matCellDef="let item" [style.vertical-align]="'top'">{{ item.number }}</td>
                        </ng-container>
                        <ng-container matColumnDef="description">
                            <td mat-cell *matCellDef="let item" [style.vertical-align]="'top'">
                                {{ item.description }}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="vote">
                            <td mat-cell *matCellDef="let item" class="vote" [style.vertical-align]="'top'">
                                @if (isChecked(item.gmAgendaItemNumber, VoteOptionEnum.Yes)) {
                                    <span>{{ 'General.Yes' | translate }}</span>
                                }

                                @if (isChecked(item.gmAgendaItemNumber, VoteOptionEnum.No)) {
                                    <span>{{ 'General.No' | translate }}</span>
                                }
                                @if (isChecked(item.gmAgendaItemNumber, VoteOptionEnum.Abstention)) {
                                    <span>{{ 'AgendaItems.Abstention' | translate }}</span>
                                }
                            </td>
                        </ng-container>
                        <tr
                            mat-row
                            *matRowDef="let row; columns: ['number', 'description', 'vote']"
                            [class.child]="row.parentGmAgendaItemNumber > 0"></tr>
                    </table>
                    @if (showAdditionalProposalsStep) {
                        <h2 class="mat-h2 mt-5">
                            {{ 'AgendaItems.AdditionalProposalsAmendments' | translate }}
                        </h2>
                        <p>
                            {{ instructionsText }}
                            <br />
                            <br />
                            <b>{{ 'AgendaItems.AdditionalProposalsAmendmentsField' | translate }}</b>
                            {{ selectedAdditionalProposals }}
                            <br />
                            @if (currentGM?.splitInstructions) {
                                <b>{{ 'AgendaItems.NewItems' | translate }}:</b>
                            }
                            {{ selectedNewItems }}
                        </p>
                    }
                </div>
            </mat-step>
        </mat-stepper>
    </mat-dialog-content>
    <mat-dialog-actions class="text-right" style="z-index: 1">
        <div class="w-100">
            @if (!hasPrevious) {
                <button mat-flat-button mat-dialog-close>
                    {{ 'General.Cancel' | translate }}
                </button>
            }
            @if (hasPrevious) {
                <button mat-flat-button (click)="stepper.previous()">
                    <mat-icon>arrow_back</mat-icon>
                    {{ 'General.Previous' | translate }}
                </button>
            }
            @if (hasNext | async) {
                <button mat-flat-button color="primary" (click)="nextStep()">
                    {{ 'General.Next' | translate }}
                    <mat-icon>arrow_forward</mat-icon>
                </button>
            }
            @if ((hasNext | async) === false) {
                <button
                    mat-flat-button
                    [class.spinner]="isSaving"
                    (click)="save()"
                    color="primary"
                    [disabled]="formGroup.invalid || isSaving || !allVotesSelected">
                    <mat-icon>send</mat-icon>
                    {{ 'General.SaveTransmit' | translate }}
                </button>
            }
        </div>
    </mat-dialog-actions>
</div>
